import React, { useState } from 'react';
import classes from './Gallery.module.css';
import Header from '../UI/Header/Header';
import { GalleryData } from '../../Assets/Data/GalleryData.js';
import Canvas from '../Canvas/Canvas';
// import Canvas from '../Canvas/Canvas';

const Gallery = () => {
  const [model, setModel] = useState(false);
  const [tempImgSrc, setTempImgSrc] = useState('');

  const getImg = imgSrc => {
    setTempImgSrc(imgSrc);
    setModel(true);
  };

  return (
    <>
      <div
        onClick={() => setModel(false)}
        className={model ? `${classes.model} ${classes.open}` : classes.model}
      >
        <img className={classes.img} src={tempImgSrc} alt="tempImgSrc" />
        <div className={classes.closebtn} onClick={() => setModel(false)}>
          {/* <ion-icon name="close"></ion-icon> */}
        </div>
      </div>
      <div className={classes.gallery_section}>
        {/* <Canvas /> */}

        <Header header="My memories" styles={classes.heading} delay="2s" />

        <div className={classes.gallery}>
          {GalleryData.map((item, index) => {
            return (
              <div
                className={classes.pics}
                key={index}
                onClick={() => getImg(item.imgSrc)}
              >
                <img
                  className={classes.pics_img}
                  src={item.imgSrc}
                  alt={`${index}`}
                  style={{ width: '100%' }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Gallery;
